import { useQueries, useQuery } from '@tanstack/react-query'
import { IUserModel } from '../../../../interfaces/models/users.interfaces'
import { IPreApprovedList } from '../../../../interfaces/models/societies.interfaces'
import { useAuth } from '../../../../hooks/useAuth'
import { userQueries } from '../../../../api/users'
import { unitQueries } from '../../../../api/units'
import { societyQueries } from '../../../../api/societies'

export const useHouseholdMembersPreApproved = (
  societyId: string | undefined
): {
  householdUsers: IUserModel[] | undefined
  preApprovedUsers: IPreApprovedList[] | undefined
} => {
  const { userId } = useAuth()
  const { data: currentUser } = useQuery(userQueries.getUser(userId))
  const { data: society } = useQuery(societyQueries.getSociety(societyId))
  const { data: userUnits } = useQuery(unitQueries.getUserUnits(userId))
  const societyUnits = userUnits?.filter((unit) => unit.societyId === societyId)
  const allUnitsResidentsList =
    societyUnits?.flatMap((_unit) => _unit.residentsList || []) || []

  const unitUsersQueries = useQueries({
    queries:
      allUnitsResidentsList.map((resident) =>
        userQueries.getUser(resident.userId)
      ) || [],
  })

  const householdUserMap = new Map<string, IUserModel>()
  if (currentUser) {
    householdUserMap.set(currentUser._id, currentUser)
  }

  const unitUsers = unitUsersQueries.flatMap((query) => query.data || [])
  unitUsers.forEach((user) => householdUserMap.set(user._id, user))

  if (!society) {
    return { householdUsers: undefined, preApprovedUsers: undefined }
  }

  const unit = societyUnits?.find((_unit) => _unit.societyId === societyId)

  const preApprovedUsers =
    society.preApprovedList?.flatMap((approved) =>
      approved.unitId === unit?._id ? approved : []
    ) || []

  return { householdUsers: [...householdUserMap.values()], preApprovedUsers }
}
